import { render, staticRenderFns } from "./IconModalView.vue?vue&type=template&id=6df45a30"
import script from "./IconModalView.vue?vue&type=script&lang=js"
export * from "./IconModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports